import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import moment from 'moment-timezone';

@Component({
  selector: 'app-referee-card',
  templateUrl: './referee-card.component.pug',
  styleUrls: ['./referee-card.component.scss'],
  standalone: false
})
export class RefereeCardComponent implements OnInit {
  @Input() referee: any;
  @Input() workHistoryStart: any;
  @Input() workHistoryEnd: any;
  @Input() resendEnabled = false;
  @Output() viewReportClick = new EventEmitter<any>();
  @Output() sendReminderClick = new EventEmitter<any>();
  coverageStart: any;
  coverageEnd: any;
  coverageOffset: any;
  coverageWidth: any;
  unusualActivityDetectedTooltip: string = $localize`Unusual activity detected`;
  markedAsSuspiciousTooltip: string = $localize`Marked as suspicious`;
  removedLabel: string = $localize`Removed`;
  refereeStateMap = {
    'requested':{
      'label': $localize`Sent`,
      'class': 'requested'
    },
    'accessed':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'started':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'agreed':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'verified':{
      'label': $localize`Accessed`,
      'class': 'in_progress'
    },
    'saved':{
      'label': $localize`Saved`,
      'class':'in_progress'
    },
    'declined':{
      'label': $localize`Declined`,
      'class':'expired'
    },
    'unobtainable':{
      'label': $localize`Unobtainable`,
      'class':'expired'
    },
    'answered':{
      'label': $localize`Answered`,
      'class':'complete'
    },
    'confirmed':{
      'label': $localize`Confirmed`,
      'class':'complete'
    },
  }

  constructor() { }

  ngOnInit(): void {
    const whStart = this.format_date(this.workHistoryStart);
    const whEnd = this.format_date(this.workHistoryEnd);
    this.coverageStart = this.format_date(this.referee['referee_start_date']);
    this.coverageEnd = this.format_date(this.referee['referee_end_date']);
    const fullWidth = this.calculateDifference(whStart,whEnd);
    const width = this.calculateDifference(this.coverageStart,this.coverageEnd);
    const leftOffset = this.calculateDifference(whStart,this.coverageStart);
    this.coverageWidth = ''+String(width/fullWidth * 100)+'%';
    this.coverageOffset = ''+String(leftOffset/fullWidth * 100)+'%';
  }

  get refereeNameTooltip(): string {
    return this.referee?.name?.length > 40 ? this.referee.name : '';
  }

  get truncatedRefereeName(): string {
    if (!this.referee?.name) return '';
    return this.referee.name.length > 40
      ? this.referee.name.substring(0, 40) + '...'
      : this.referee.name;
  }

  get refereeEmail(): string {
    return this.contactValue(this.referee?.email);
  }

  get refereePhone(): string {
    return this.contactValue(this.referee?.phone);
  }

  // Purged referees arrive with PII overwritten by the literal string 'removed';
  // surface that as a localised "Removed" label rather than the raw sentinel.
  private contactValue(value: string): string {
    if (!value) return '-';
    return value.toLowerCase() === 'removed' ? this.removedLabel : value;
  }

  get roleAtOrgTooltip(): string {
    const fullText = `${this.referee?.role || ''} at ${this.referee?.company_name || ''}`;
    return fullText.length > 40 ? fullText : '';
  }

  get truncatedRoleAtOrg(): string {
    if (!this.referee?.role || !this.referee?.company_name) return '';
    const fullText = `${this.referee.role} at ${this.referee.company_name}`;
    return fullText.length > 40
      ? fullText.substring(0, 40) + '...'
      : fullText;
  }

  format_date(date_dict: any) {
    return moment(date_dict.year+'-'+ date_dict.month +'-'+ date_dict.day, "YYYY-MM-DD").format('DD MMM YYYY');
  }

  calculateDifference(startDate, endDate) {
    var start = new Date(startDate);
    var end = new Date(endDate);
    return Math.floor((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24);
  }

  onViewReportClick() {
    this.viewReportClick.emit(this.referee);
  }

  get showSendReminder(): boolean {
    const blocked = ['answered', 'confirmed', 'declined', 'detached'];
    return this.resendEnabled && !!this.referee && blocked.indexOf(this.referee.status) === -1;
  }

  get reminderButtonLabel(): string {
    return this.referee?.reminderSent ? $localize`Reminder sent` : $localize`Send reminder`;
  }

  get lastReminderTooltip(): string {
    if (!this.resendEnabled) {
      return '';
    }
    const lastReminderAt = this.referee?.last_reminder_at;
    if (!lastReminderAt) {
      return '';
    }
    return $localize`Last reminder: ${moment(lastReminderAt).format('D MMM YYYY')}`;
  }

  onSendReminderClick() {
    if (!this.resendEnabled || this.referee?.reminderSent) {
      return;
    }
    this.sendReminderClick.emit(this.referee);
  }

}
